import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CartItemQuantitySelectorComponent } from 'cart-ui';
import { ProductResultLayoutComponentsProviderComponentBase, RenderInProductResultLayoutDirective } from 'products-ui';

@Component({
  selector: 'ideal-import-standard-product-result-components',
  imports: [CartItemQuantitySelectorComponent, RenderInProductResultLayoutDirective],
  standalone: true,
  templateUrl: './import-standard-product-result-components.component.html',
  styleUrl: './import-standard-product-result-components.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImportStandardProductResultComponentsComponent extends ProductResultLayoutComponentsProviderComponentBase {}
